import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-stone font-mono text-sm">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/auth" replace />;
  return children;
}
